import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ApiService from '../../../services/apiService';

const ViewItemGrid = ({ grnData, currencyPrecision,
    setOverallDiscount, grandTotal, setVatAmount, vatAmount, selectedPOData, itemData,
    overallDiscount, setDiscountAmount, discountAmount, setGrandTotal }) => {


    const [columnWidths, setColumnWidths] = useState({
        srNo: 70,
        itemNo: 100,
        description: 130,
        specification: 120,
        qty: 70,
        uom: 130,
        inventoryQty: 130,
        balQty: 80,
        freeQty: 100,
        unitPrice: 120,
        discount: 100,
        calculatedAmount: 100,
        vatDesc: 100,
        vat: 80,
        vatAmount: 120,
        amount: 100,
        batchNo: 120,
        expDate: 130
    });

    const ResizableHeader = ({ column, children }) => {
        return (
            <th
                style={{
                    width: `${columnWidths[column]}px`,
                    minWidth: `${columnWidths[column]}px`,
                    position: 'relative'
                }}
            >
                {children}

                <span
                    className="resize-handle"
                    onMouseDown={(e) => startResize(e, column)}
                />
            </th>
        );
    };

    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        qty: '',
        uom: '',
        vatDes: '',
        baseQty: '',
        baseAmount: '',
        amount: '',
        discount: '',
        vat: '',
        convValue: '',
        vatAmount: '',
        calculatedAmount: "",
        expDate: null,
        balQty: "",
        batchNo: "",
        inventoryAccountCode: "",
        inventoryAccountName: "",
    }]);
    const [overallDiscountAmount, setOverallDiscountAmount] = useState(); // Amount
    const [POActualQty, setPOactualQty] = useState(); // actualQty

    const calculatedTotal = rows.reduce((sum, row) => {
        const amount = parseFloat(row?.amount) || 0;
        const vatAmount = parseFloat(row?.vatAmount) || 0;
        const discount = parseFloat(row?.discount) || 0;
        let final = overallDiscount === 0 ? ((amount + discount) - vatAmount) : (amount - vatAmount)

        return sum + (final);
    }, 0);
    const totalItemDiscount = rows.reduce((sum, row) => { return sum + Number(row?.discount || 0); }, 0);


    useEffect(() => {
        const getItems = async () => {
            try {
                const apiService = new ApiService();
                let param = `?POrderNo=View?POrderNo=View&GRNNo=${itemData}&Mode=2`
                const PO = await apiService.getApiParamater("GET_PO_ITEM_UPDATE", param);
                const Item = grnData?.filter(rec => rec.qty > 0)

                const formattedRowsitm = Item?.map(async (detail, index) => {
                    const selecteditms = await apiService.getApiParamater("GET_ITEM", `?ItemNo=${detail.itemCode}`);
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                    const selectedGrnItem = PO.data.result?.find(rec => rec.itemDescription === detail.itemDescription)
                    const selectedOPItem = selectedPOData?.poDetails?.find(rec => rec.itemDescription === detail.itemDescription)
                    let glAccount = getGLAccounts?.data?.result[0]
                    let itm = selecteditms?.data?.result[0]
                    const discountdinal = (selectedOPItem?.discount / selectedGrnItem?.actualPOQty);

                    let discount = (discountdinal * detail.qty)
                    let ActualDiscount = (discountdinal * selectedGrnItem?.balQty)
                    const gross = Number(detail.qty || 0) * Number(detail.unitPrice || 0);
                    const afterDiscount = (gross - discount) || 0;
                    const vatAmount = afterDiscount * Number(detail.vatPerc || 0) / 100;
                    const finalAmount = afterDiscount + vatAmount;
                    return {
                        requisitionNo: detail.requisitionNo,
                        srno: detail?.srno,
                        ItemNo: detail.itemCode,
                        qty: detail.qty,
                        itemDescription: detail.itemDescription,
                        uom: detail.uom,
                        baseQty: itm.convToInvUOM * detail.qty,
                        baseAmount: detail.unitPrice?.toFixed(4),
                        vat: detail.vatPerc,
                        discount: discount?.toFixed(currencyPrecision || 3) || 0,
                        vatDes: detail.vatDesc,
                        convValue: itm.convToInvUOM,
                        vatAmount: detail.vatAmount?.toFixed(currencyPrecision || 3),
                        freeQty: detail?.extraQty || 0,
                        specification: detail ? detail.specification : '',
                        amount: detail?.amount?.toFixed(currencyPrecision || 3),
                        balQty: selectedGrnItem?.balQty,
                        calculatedAmount: afterDiscount?.toFixed(currencyPrecision || 3) || 0,
                        expDate: detail?.expDate,
                        batchNo: detail?.batchNo,
                        inventoryAccountCode: glAccount.inventoryAccountCode,
                        inventoryAccountName: glAccount.inventoryAccountName,
                        GRNAccountName: glAccount.grnAccountName,
                        GRNAccountCode: glAccount.grnAccountCode,
                        originalDiscount: ActualDiscount,
                        actualqty: selectedGrnItem?.actualPOQty
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsitm);
                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };

        if (itemData) {
            getItems();
        }
    }, [itemData, selectedPOData]);

    useEffect(() => {
        const grossAmount = rows.reduce(
            (sum, row) => sum + Number(row?.amount - row?.vatAmount || 0),
            0
        );

        const totalQty = selectedPOData?.poDetails?.reduce(
            (sum, row) => sum + Number(row?.qty || 0),
            0
        );
        const qty = rows.reduce(
            (sum, row) => sum + Number(row?.qty || 0),
            0
        );
        const overallamount = selectedPOData?.poDetails?.reduce(
            (sum, row) => sum + Number(row?.qty * row?.unitPrice),
            0
        );
        const vat = 10;
        // Overall discount amount
        const discountam = (overallamount * overallDiscount) / 100;
        const discountPerQty = totalQty > 0 ? discountam / totalQty : 0;
        const discountAmt = overallDiscount === 0 ? totalItemDiscount : (qty * discountPerQty);

        // Discount per qty

        // Amount after discount
        const amountAfterDiscount = calculatedTotal - discountAmt;

        // VAT
        // const vatAmount = (amountAfterDiscount * vat) / 100;

        // const vatAmount = rows.reduce((sum, row) => sum + (Number(row?.vatAmount) || 0), 0);
        let vatAmount = 0;
        if (rows.length === 1) {

            const vatRate = rows[0]?.vat;
            vatAmount = (amountAfterDiscount * vatRate) / 100;
        } else {
            // Get unique VAT rates
            const uniqueVatRates = [
                ...new Set(rows.map((r) => Number(r?.vat || 0))),
            ];

            if (uniqueVatRates.length === 1) {
                // Same VAT on all rows
                const vatRate = uniqueVatRates[0];
                vatAmount = (amountAfterDiscount * vatRate) / 100;
            } else {
                // Different VAT rates
                vatAmount = rows.reduce(
                    (sum, row) => sum + Number(row?.vatAmount || 0),
                    0
                );
            }
        }
        // Grand Total
        const grandTotal = amountAfterDiscount + vatAmount;


        // Optional: update rows with per qty discount
        const updatedRows = rows.map((row) => ({
            ...row,
            discountPerQty,
        }));

        // Only if you want to save it in state
        // setRows(updatedRows);

        setDiscountAmount(discountAmt);
        setOverallDiscountAmount(discountam);
        setVatAmount(vatAmount);
        setGrandTotal(grandTotal);

        // If you need discountPerQty elsewhere
        // setDiscountPerQty(discountPerQty);

    }, [rows, overallDiscount, totalItemDiscount]);


    const startResize = (e, column) => {
        e.preventDefault();

        const startX = e.clientX;
        const startWidth = columnWidths[column];

        const handleMouseMove = (event) => {
            const newWidth = Math.max(
                50,
                startWidth + (event.clientX - startX)
            );

            setColumnWidths(prev => ({
                ...prev,
                [column]: newWidth
            }));
        };

        const handleMouseUp = () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    return (
        <div>
            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Discount %</label>
                    <input
                        type="number"
                        className="form-control"
                        value={overallDiscount}
                        disabled
                    />
                </div>
                <div className="col-md-4">
                    <label>Discount Amount</label>
                    <input
                        type="number"
                        className="form-control"
                        value={overallDiscountAmount}
                        disabled
                    />
                </div>
            </div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <ResizableHeader column="srNo">Sr no</ResizableHeader>
                            <ResizableHeader column="itemNo">Item No</ResizableHeader>
                            <ResizableHeader column="description">Description</ResizableHeader>
                            <ResizableHeader column="specification">Item Specs</ResizableHeader>
                            <ResizableHeader column="qty">Qty</ResizableHeader>
                            <ResizableHeader column="uom">Packing UOM</ResizableHeader>
                            <ResizableHeader column="inventoryQty">Inventory Qty</ResizableHeader>
                            <ResizableHeader column="balQty">Bal Qty</ResizableHeader>
                            <ResizableHeader column="freeQty">Free Qty</ResizableHeader>
                            <ResizableHeader column="unitPrice">Unit Price</ResizableHeader>
                            <ResizableHeader column="discount">Discount</ResizableHeader>
                            <ResizableHeader column="calculatedAmount">Calculated Amount</ResizableHeader>
                            <ResizableHeader column="vatDesc">VAT Desc</ResizableHeader>
                            <ResizableHeader column="vat">VAT %</ResizableHeader>
                            <ResizableHeader column="vatAmount">VAT Amount</ResizableHeader>
                            <ResizableHeader column="amount">Amount</ResizableHeader>
                            <ResizableHeader column="batchNo">Batch No</ResizableHeader>
                            <ResizableHeader column="expDate">Exp Date</ResizableHeader>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row, index) => (
                            <tr key={index}>

                                {/* Sr No */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.srNo}px`,
                                        minWidth: `${columnWidths.srNo}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        value={index + 1}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Item No */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.itemNo}px`,
                                        minWidth: `${columnWidths.itemNo}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.ItemNo}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Description */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.description}px`,
                                        minWidth: `${columnWidths.description}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.itemDescription}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Item Specs */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.specification}px`,
                                        minWidth: `${columnWidths.specification}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.specification}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.qty}px`,
                                        minWidth: `${columnWidths.qty}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                        value={row.qty} disabled
                                    />
                                </td>

                                {/* Packing UOM */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.uom}px`,
                                        minWidth: `${columnWidths.uom}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.uom}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Inventory Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.inventoryQty}px`,
                                        minWidth: `${columnWidths.inventoryQty}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.baseQty}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Bal Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.balQty}px`,
                                        minWidth: `${columnWidths.balQty}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={row.balQty || 0}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Free Qty */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.freeQty}px`,
                                        minWidth: `${columnWidths.freeQty}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="number"
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                        value={row.freeQty} disabled
                                    />
                                </td>

                                {/* Unit Price */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.unitPrice}px`,
                                        minWidth: `${columnWidths.unitPrice}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        onWheel={(e) => e.target.blur()}
                                        type="number"
                                        value={row.baseAmount}
                                        disabled
                                    />
                                </td>

                                {/* Discount */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.discount}px`,
                                        minWidth: `${columnWidths.discount}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={row.discount}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Calculated Amount */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.calculatedAmount}px`,
                                        minWidth: `${columnWidths.calculatedAmount}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={row.calculatedAmount}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* VAT Desc */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.vatDesc}px`,
                                        minWidth: `${columnWidths.vatDesc}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={row.vatDes}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* VAT % */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.vat}px`,
                                        minWidth: `${columnWidths.vat}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={`${row.vat || 0}%`}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* VAT Amount */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.vatAmount}px`,
                                        minWidth: `${columnWidths.vatAmount}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="text"
                                        value={Number(row?.vatAmount || 0).toFixed(
                                            currencyPrecision || 3
                                        )}
                                        disabled
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Amount */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.amount}px`,
                                        minWidth: `${columnWidths.amount}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        disabled
                                        value={Number(row?.amount || 0).toFixed(
                                            currencyPrecision || 3
                                        )}
                                        style={{ width: "100%", boxSizing: "border-box" }}
                                    />
                                </td>

                                {/* Batch No */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.batchNo}px`,
                                        minWidth: `${columnWidths.batchNo}px`
                                    }}
                                >
                                    <input
                                        className="p-2"
                                        type="number"
                                        value={row.batchNo}
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </td>

                                {/* Exp Date */}
                                <td
                                    className="m-0 p-0"
                                    style={{
                                        width: `${columnWidths.expDate}px`,
                                        minWidth: `${columnWidths.expDate}px`
                                    }}
                                >
                                    <input className='p-2' type='date' value={row?.expDate ? row.expDate.split('T')[0] : ''} disabled
                                        style={{
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }} />
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-between boxs">
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Amount</div>
                    <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">_</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Discount</div>
                    <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">After Discount</div>
                    <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">+</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Vat</div>
                    <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Net Amount</div>
                    <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
            </div>
        </div>
    );
};

export default ViewItemGrid;